var isGetLiveUsersActive = false
var isGetLiveReceiver = false
var ActiveUsers = []
export var SOCKET;

export const GetLiveUsers = (callback) => {
    if (!isGetLiveUsersActive) {
        if (SOCKET) {
            isGetLiveUsersActive = true
            SOCKET.on("live_users_list", function (data) {
                if (data.data === "NEW") {
                    if (ActiveUsers.find(raw => raw.user_id == data.liveusers[0].user_id)) {
                        callback(ActiveUsers)
                        // do nothing...
                    } else {
                        ActiveUsers.push(data.liveusers[0]);
                        callback(ActiveUsers)
                        // call back
                    }
                }
                else if (data.data === "ALL") {
                    ActiveUsers = data.liveusers
                    callback(ActiveUsers)
                    // call back
                }
                else if (data.data === "DELETE") {
                    if (data.liveusers) {
                        if (data.liveusers.length > 0) {
                            var del_obj = ActiveUsers.findIndex(x => x.user_id === data.liveusers[0].user_id);
                            if (del_obj > -1) {
                                ActiveUsers.splice(del_obj, 1)
                                callback(ActiveUsers)
                                // callback

                            }
                        }
                    }

                }
                else if (data.data === "UPDATE") {
                    var del_obj = ActiveUsers.findIndex(x => x.user_id === data.liveusers[0].user_id);
                    if (del_obj > -1) {
                        ActiveUsers[del_obj] = data.liveusers[0];
                        callback(ActiveUsers)
                        // callback
                    }
                }
            });
        }
        else {
            setTimeout(() => {
                GetLiveUsers(callback)
            }, 1000);
        }

    } else {
        callback(ActiveUsers)
    }
}
export const UpdateSocket = (socket) => {
    if (!SOCKET) {
        SOCKET = socket
    }
}


//
export const GetLiveReceiver = (callback) => {
    if (!isGetLiveReceiver) {
        if (SOCKET) {
            isGetLiveReceiver = true
            SOCKET.on("F_MESSAGE_EVENT", function (data) {
                callback(data)
            });
        }
        else {
            setTimeout(() => {
                GetLiveReceiver(callback)
            }, 1000);
        }

    } else {
        callback(ActiveUsers)
    }
}
export const ReconnectReceiver = (callback) => {
    if (SOCKET) {
        SOCKET.on('reconnect', function () {
            callback(true)
        })
    }
    else {
        setTimeout(() => {
            ReconnectReceiver(callback)
        }, 1000);
    }
}

export const SendEmit = (data) => {
    SOCKET.emit("B_MESSAGE_EVENT", data)
}